exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-input.priority li {\n  color: white;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 9999px;\n}\n.form-input.priority li .critical {\n  background-color: #f32144;\n}\n.form-input.priority li .important {\n  background-color: orange;\n}\n.form-input.priority li .normal {\n  background-color: #f7a913;\n}\n.form-input.priority li .normal {\n  background-color: #085FCE;\n}", ""]);

// exports
